<template>
  <div class="c-modal c-modal--contact" :class="{'is-active': isActive}">
    <div class="c-modal__bg"></div>
    <div class="c-modal__content">
      <div class="c-modal__close" @click="close">
        <div class="c-icon c-icon--white u-wh14">
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <use xlink:href="/assets/img/sprite.svg#close" />
          </svg>
        </div>
      </div>
      <div class="c-modal__inner">
        <div class="c-modal__title">
          Firebase構成オブジェクトを貼り付けると情報がコピーされます
        </div>
        <div class="c-modal__data">
          <div class="c-textarea">
            <textarea
              v-model="config"
              style="min-height: 100px"
              class="c-textarea__item"
              name="content"
              placeholder=""
            ></textarea>
            <div class="c-error c-error--balloon">
              <div class="c-error__text"></div>
            </div>
          </div>
        </div>
        <div class="c-modal__btns" @click="apply">
          <a class="c-btn c-btn--modal c-btn--gray u-w240 u-h34 u-fs14">
            <p class="c-btn__text">反映して閉じる</p>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
  },
  emits: ["apply-config"],
  data () {
    return {
      isActive: false,
      config: ''
    }
  },
  methods: {
    open: function () {
      this.isActive = true;
    },
    close: function () {
      this.isActive = false;
    },
    apply: function () {
      try {
        const firebaseConfig = new Function('return (function () { ' + this.config + 'return firebaseConfig;})()')();
        this.$emit("apply-config", firebaseConfig);
      } catch {
        console.error('Firebase設定を読み込めませんでした。');
      }
      this.isActive = false;
    }
  },
};
</script>
